import { EstateEntitiesTable } from '@/modules/estate/EstateEntitiesTable/EstateEntitiesTable';

export function ClientEstateEntitiesPage() {
  return <EstateEntitiesTable />;
}
